// vim: set ts=2 sw=2 et ft=javascript:
/*
 * Copyright (C) 2014 Minted Inc.
 *
 * All Rights Reserved
 */
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/backbone-1.0.0.min': 'Backbone',
  'minted:vendor/jquery-1.9.1.min': '$',
  'minted:vendor/underscore-1.8.2.min': '_',
  'templito:dropdown_picker': []
})(this, function (m_module, Backbone, $, _) {
  "use strict";

  M.View = M.View || {};

  /**
   * @class DropdownPicker
   *
   * Renders styled dropdown picker. Takes a model which holds list
   * of dropdown options and the currently selected option. When
   * dropdown picker is opened, a backdrop div with z-index = 1 is
   * added which closes the dropdown picker when clicking outside
   * of picker.
   *
   * Arguments:
   * - model: dropdown picker model
   * - pickerLabel: string, label for the picker
   */
  M.View.DropdownPicker = Backbone.View.extend({
    tagName: 'div',
    className: 'dropdownPicker',

    events: {
      'click .dropdownPickerItem': 'itemClickHandler',
      'click .dropdownPickerTrigger': 'triggerClickHandler'
    },

    template: M.Template.DropdownPicker.DropdownPicker,

    initialize: function() {
      M.required(this.model);
      this.$el = $(this.el);

      _.bindAll(this, 'render');
      this.model.bind("change:selectedSortOption", this.render);
      this.disableFirstOption = this.options.disableFirstOption || false;
    },

    render: function() {
      var html;

      var sortOptionsList = this.model.get('sortOptionsList');
      var selectedSortOption = this.model.get('selectedSortOption');

      // default selected option to first in list
      var selectedOptionDisplayStr = sortOptionsList[0]['display_str'];
      for (var i in sortOptionsList) {
        if (sortOptionsList[i]['option_val'] == selectedSortOption) {
          selectedOptionDisplayStr = sortOptionsList[i]['display_str'];
          if (this.disableFirstOption) {
            sortOptionsList = _.without(sortOptionsList, sortOptionsList[0]);
          }

          break;
        }
      }

      html = this.template({
        'sortOptionsList': sortOptionsList,
        'selectedOptionDisplayStr': selectedOptionDisplayStr,
        'pickerLabel': this.options.pickerLabel
      });
      this.$el.empty();
      this.$el.append(html);

      // Hide the droplist (only shows on click)
      this.$el.find('.dropdownPickerDataSource').hide();

      return this;
    },

    itemClickHandler: function(e) {
      var clickedVal = $(e.target).attr('val');
      this.model.set({'selectedSortOption': clickedVal});
      this.closeDropdown();
    },

    disable: function() {
      this.disabled = true;
    },

    enable: function() {
      this.disabled = false;
    },

    triggerClickHandler: function() {
      if (this.disabled) {
        return;
      }
      var dropdownList = this.$el.find('.dropdownPickerDataSource');
      var dropdownOpen = dropdownList.is(':visible');
      if (!dropdownOpen) {
        // Show the dropdown list and append backdrop element click handler
        this.$el.find('.dropdownPickerDataSource').show();

        // Insert a backdrop to handle clicking outside of dropbox
        // css class has z-index of 1 to keep backdrop on top of all
        // page elements
        var backdropElement = '<div class="backdropDiv"></div>';
        $(backdropElement).insertAfter(dropdownList).on(
          'click', this.backdropClickHandler);

      } else {
        // Close dropdown list and delete backdropDiv
        this.closeDropdown();
      }
    },

    closeDropdown: function() {
      var dropdownList = this.$el.find('.dropdownPickerDataSource');
      dropdownList.hide();
    },

    backdropClickHandler: function() {
      var dropdownList = $(this).parent().find('.dropdownPickerDataSource');
      dropdownList.hide();
      // Remove the backdrop
      $(this).remove()
    }

  });

  return {
    DropdownPicker: M.View.DropdownPicker 
  };

});
